export function ValidateConfirmCode(confirmCode) {
  var reg = new RegExp("\\d{6}");
  if (reg.test(confirmCode) == false) return false;

  return true;
}
